import axios from 'axios'
import { FetchProducerBySlugQuery, ParentProducer } from 'types/producer'
import { stringify } from 'qs'
import { GetParentProducerBySlugResponse } from 'types/bolt-api/request'

/**
 * Get parent producer by slug
 *
 * @param {string} slug
 * @param {FetchProducerBySlugQuery} [params]
 * @returns {Promise<Producer | undefined>}
 */
const getParentProducerBySlug = async (slug: string, params?: FetchProducerBySlugQuery): Promise<ParentProducer | undefined> => {
  try {
    const query = stringify(params, { addQueryPrefix: true, skipNulls: true })
    const { data } = await axios.get<GetParentProducerBySlugResponse>(`${process.env.API_URL}/producers/parents/${slug}${query}`, {
      headers: {
        Authorization: `Basic ${process.env.API_TOKEN}`
      }
    })

    return data?.producer
  } catch (_) {
    return undefined
  }
}

export default getParentProducerBySlug
